import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserMentionContentDirective } from './directives/user-mention-content.directive';

@NgModule({
    declarations: [UserMentionContentDirective],
    imports: [
        CommonModule
    ],
    exports: [UserMentionContentDirective]
})
export class UserMentionsModule { }
